const formatDateToYYYYMMDD = (date) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default formatDateToYYYYMMDD;

export function formatNotificationDate(dateString) {
  const notificationDate = new Date(dateString);
  const now = new Date();

  const isToday =
    notificationDate.getDate() === now.getDate() &&
    notificationDate.getMonth() === now.getMonth() &&
    notificationDate.getFullYear() === now.getFullYear();

  if (isToday) return "Today";

  const day = notificationDate.getDate();
  const month = notificationDate.toLocaleString("en-US", { month: "short" });
  const year = notificationDate.getFullYear();

  const isSameYear = year === now.getFullYear();
  return isSameYear ? `${day} ${month}` : `${day} ${month}, ${year}`;
}

export function formatDateToDDMYY(date) {
  if (!date) return null;

  const parsedDate = new Date(date);

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
}
